import { ICmsContentService } from '../icms-content.service';
import { NICmsContentPageType } from '../interfaces/icms-content-page-type.interfaces';

export function ICmsPageType(meta: NICmsContentPageType.IMeta) {
    return (type: any) => {
        ICmsContentService.registerPageType(meta);
        return type;
    };
}
